// PaymentProfileService.tsx
import { useInfiniteQuery } from '@tanstack/react-query';
import { PaymentProfileService } from '../../core/services';
import { PageSize } from '../../type';

export const useGetPaymentService = (initialParams: PageSize) => {
  const { data, isLoading, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isFetching } =
    useInfiniteQuery({
      queryKey: ['get-payments-data'],
      queryFn: async ({ pageParam }) => {
        return PaymentProfileService.getPayment({
          page: initialParams.pageNumber ?? pageParam,
          size: initialParams.size,
          paymentNo: initialParams.paymentNo,
          referenceNo: initialParams.referenceNo,
          clientName: initialParams.clientName,
          start: initialParams.start,
          end: initialParams.end,
          accountId: initialParams.accountId,
          userId: initialParams.userId,
          vehicleId: initialParams.vehicleId,
          typeName: initialParams.typeName,
        });
      },
      initialPageParam: 1,
      getNextPageParam: (res) => (!res?.last ? res?.number + 1 : undefined),
      enabled: false,
      retry: 1,
      retryDelay: 36000000,
    });
  const isDataFetching = isFetching || isFetchingNextPage;

  return {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isDataFetching,
  };
};

export const useGetPaymentModesService = (initialParams: PageSize) => {
  const { data, isLoading, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isFetching } =
    useInfiniteQuery({
      queryKey: ['get-payment-modes-data'],
      queryFn: async ({ pageParam }) => {
        return PaymentProfileService.getPaymentMode({
          page: initialParams.pageNumber ?? pageParam,
          size: initialParams.size,
          title: initialParams.title,
        });
      },
      initialPageParam: 1,
      getNextPageParam: (res) => (!res?.last ? res?.number + 1 : undefined),
      enabled: false,
      retry: 1,
      retryDelay: 36000000,
    });
  const isDataFetching = isFetching || isFetchingNextPage;

  return {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isDataFetching,
  };
};

export const useGetPaymentModesDropdownService = (initialParams: PageSize) => {
  const { data, isLoading, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isFetching } =
    useInfiniteQuery({
      queryKey: ['get-payment-mode-dropdown-data'],
      queryFn: async ({ pageParam }) => {
        return PaymentProfileService.getPaymentModeDropdown({
          page: initialParams.pageNumber ?? pageParam,
          size: initialParams.size,
          title: initialParams.title,
        });
      },
      initialPageParam: 1,
      getNextPageParam: (res) => {
        return !res?.last ? res?.number + 1 : undefined;
      },
      enabled: false,
    });
  const isDataFetching = isFetching || isFetchingNextPage;

  return {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isDataFetching,
  };
};
